import styled from 'styled-components';
export const Title = styled.p`
  font-weight: bolder;
  font-size: 1.125em;
  text-align: center;
  color: #8662c7;
`;
export const Content = styled.p`
  font-size: 1.125em;
  text-align: center;
  color: #ffffff;
  margin: 0;
`;
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Image = styled.img`
  align-self: center;
`;